// extracted by mini-css-extract-plugin
export default {"spaser":"IsClubRegistered_spaser__8nWS7"};